import { formValidation } from "@form-validation/bundle/full";
import { Trigger } from "@form-validation/plugin-trigger";
import { Bootstrap5 } from "@form-validation/plugin-bootstrap5";
import { SubmitButton } from "@form-validation/plugin-submit-button";
import { Wizard } from "@form-validation/plugin-wizard";

import progressStepWizard from "../../js/progressStepWizard";

document.addEventListener("DOMContentLoaded", (event) => {
  const form = document.getElementById("formRegister");

  const btn_person_check = document.getElementById("btnStdCheck");
  const btn_password_toggle = document.getElementById("btnPassToggle");
  const std_code_input = form.querySelector('[name="std_code"]');
  const password_input = form.querySelector('[name="password"]');

  const btn_previous = document.getElementById("prevButton");
  const btn_next = document.getElementById("nextButton");
  const notEmptyMsg = "ไม่เว้นว่าง";
  const fv_form = formValidation(form, {
    fields: {
      std_code: {
        validators: {
          notEmpty: { message: notEmptyMsg },
          regexp: { regexp: /^[0-9]{8}$/, message: "รหัสนิสิต 8 หลัก" },
        },
      },
      password: {
        validators: {
          notEmpty: { message: notEmptyMsg },
        },
      },
      std_check: {
        validators: {
          notEmpty: { message: notEmptyMsg },
        },
      },
      nickname: {
        validators: {
          notEmpty: { message: notEmptyMsg },
        },
      },
      prefix_id: {
        validators: {
          notEmpty: { message: notEmptyMsg },
        },
      },
      name: {
        validators: {
          notEmpty: { message: notEmptyMsg },
        },
      },
      surname: {
        validators: {
          notEmpty: { message: notEmptyMsg },
        },
      },
      username: {
        validators: {
          notEmpty: { message: notEmptyMsg },
        },
      },
      firstname_en: {
        validators: {
          notEmpty: { message: notEmptyMsg },
        },
      },
      lastname_en: {
        validators: {
          notEmpty: { message: notEmptyMsg },
        },
      },
      idcard: {
        validators: {
          notEmpty: { message: notEmptyMsg },
          id: {
            country: "TH",
            message: "ตัวเลขรหัสบัตรประชาชน 13 หลัก",
          },
        },
      },
      department_id: {
        validators: {
          notEmpty: { message: notEmptyMsg },
        },
      },
      branch_id: {
        validators: {
          notEmpty: { message: notEmptyMsg },
        },
      },
      level_year: {
        validators: {
          notEmpty: { message: notEmptyMsg },
          regexp: {
            regexp: /^[1-4]{1}$/,
            message: "ชั้นปีเลข 1 หลัก",
          },
        },
      },
      gender: {
        validators: {
          notEmpty: { message: notEmptyMsg },
        },
      },
      telephone: {
        validators: {
          notEmpty: { message: notEmptyMsg },
          regexp: {
            regexp: /^[0-9]{9,10}$/,
            message: "เบอร์โทรศัพท์ 9-10 หลัก",
          },
        },
      },
      email: {
        validators: {
          notEmpty: { message: notEmptyMsg },
        },
      },
    },
    plugins: {
      trigger: new Trigger(),
      bootstrap5: new Bootstrap5({
        rowSelector: ".fv-mark",
        defaultMessageContainer: false,
      }),
      submitButton: new SubmitButton(),
      wizard: new Wizard({
        stepSelector: ".js-step",
        prevButton: "#prevButton",
        nextButton: "#nextButton",
      }),
    },
  })
    .on("plugins.wizard.step.active", function (e) {
      btn_previous.style.display = e.step == 0 ? "none" : "inline-block";
      btn_next.innerHTML = e.step === e.numSteps - 1 ? '<i class="bi bi-save me-2"></i>ลงทะเบียน' : 'ต่อไป<i class="bi bi-arrow-right ms-2"></i>';
    })
    .on("plugins.wizard.valid", function (e) {
      bootbox.confirm({
        locale: 'th',
        size: "sm",
        className: 'modal-confirm',
        title: '<i class="bi bi-exclamation-triangle me-2"></i>ยืนยัน',
        centerVertical: true,
        message: `<span class="fw-bold">ยืนยันการบันทึกข้อมูล ?</span><br>
                  <span class="small text-warning"><i class="bi bi-dash"></i> ตรวจสอบข้อมูลให้ถูกต้องอีกครั้ง</span>
                  <span class="small text-warning"><i class="bi bi-dash"></i> ข้อมูลที่ไม่สามารถเปลี่ยนแปลงได้หลังจากบันทึกประกอบด้วย</span>
                  <ul class="my-0"><li>ภาควิชา</li><li>สาขาวิชา</li></ul>`,
        buttons: {
          confirm: {
            label: '<i class="bi bi-save me-2"></i>บันทึก',
            className: "btn-success",
          }
        },
        swapButtonOrder: true,
        callback: async (result) => {
          if (result) {
            form.submit();
          }
        },
      });
    });

  /// เช็คสถานะของผู้ใช้งานว่าอยู่ในมหาวิทยาลัยหรือไม่
  btn_person_check.addEventListener("click", (e) => {
    fv_form.validateField("std_code");
    fv_form.validateField("password");
    if (Number.isInteger(parseInt(std_code_input.value)) && std_code_input.value && password_input.value) {
      e.target.disabled = std_code_input.readOnly = password_input.readOnly = true;
      e.target.innerHTML = '<span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span><span role="status">ตรวจสอบ...</span>';
      const form_data = new FormData(form);
      const ajax_data = func.fetchData("ajax/student/check", form_data).then((response) => {
        const show = document.getElementById("showStdCheck");
        const check = form.querySelector('[name="std_check"]');
        e.target.innerHTML = "ตรวจสอบ";
        show.innerHTML = response.message;
        console.log(response);

        if (response.checked == 'pass') {
          setFormValue(response.data);
          show.classList.remove("text-bg-danger");
          show.classList.add("text-bg-success");
          btn_next.classList.remove("d-none");
          password_input.parentElement.parentElement.classList.add("d-none");
          password_input.value = null;
          check.value = response.checked;
          fv_form.resetField("password");
          btn_next.focus();
        } else {
          check.value = null;
          e.target.disabled = std_code_input.readOnly = password_input.readOnly = false;
          show.classList.add("text-bg-danger");
          show.classList.remove("text-bg-success");
          btn_next.classList.add("d-none");
          fv_form.resetField("std_code").resetField("password");
        }
      });
    } else {
      fv_form.validate();
    }
  });

  // เลือกสาขาวิชา
  form.querySelector('[name="department_id"]').addEventListener("change", (e) => {
    selectBranch(e.target.value);
  });

  function selectBranch(department_id) {
    let html = '<option value="">เลือกสาขาวิชา</option>';
    const ajax_form_data = new FormData();
    ajax_form_data.append("department_id", department_id);
    ajax_form_data.append("active", 1);
    const ajax_upload_status = func.fetchData(func.host_url("ajax/branch"), ajax_form_data);
    ajax_upload_status.then((data) => {
      data.data_value.forEach((val) => {
        html += "<option value=" + val.id + ">" + val.name + "</option>";
      });
      form.querySelector('[name="branch_id"]').innerHTML = html;
      fv_form.validateField("branch_id");
    });
  }

  btn_password_toggle.addEventListener("click", (e) => {
    ["bi-eye-slash", "bi-eye"].map((v) => e.currentTarget.querySelector("i.bi").classList.toggle(v));
    if (password_input.type === "password") {
      password_input.type = "text";
    } else {
      password_input.type = "password";
    }
  });

  function setFormValue(data) {
    const fv_field = fv_form.fields;
    Object.entries(fv_field).forEach((entry) => {
      const [field_name] = entry;
      let _field = form.querySelector('[name="' + field_name + '"]');
      if (_field && !["std_check"].includes(_field.name)) {
        if (_field.type == "text") {
          setText(_field, data);
        }
        if (_field.type == "email") {
          setEmail(_field, data);
        }
        if (_field.type == "select-one") {
          setSelect(_field, data, !["gender"].includes(_field.name));
        }
      }
    });
  }

  function setText(field, data) {
    if (data[field.dataset.nudb] !== undefined) field.value = data[field.dataset.nudb];
  }

  function setEmail(field, data) {
    if (data[field.dataset.nudb] !== undefined) field.value = data[field.dataset.nudb] + "@nu.ac.th";
  }

  function setSelect(field, data, byText = true) {
    const _textToFind = data[field.dataset.nudb];
    for (let i = 0; i < field.options.length; i++) {
      if ((byText ? field.options[i].text : field.options[i].value) === _textToFind) {
        field.selectedIndex = i;
        if (field.dataset.nudb == "DEPARTMENTNAME") {
          selectBranch(i);
        }
        break;
      }
    }
  }
  
  const progress_step = new progressStepWizard("progressStepWizard", fv_form);
  fv_form.on("plugins.wizard.step.active", function (e) {
    progress_step.goToStep(e.step);
  });

  window.onload = func.require_icon(form, fv_form.fields);
});
